import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { PipesModule } from '@app/pipes';
import Chart from 'chart.js/auto';

@Component({
  selector: 'mnf-pi-v2-opp-scheme',
  standalone: true,
  imports: [CommonModule, PipesModule],
  templateUrl: './pi-v2-opp-scheme.component.html',
  styleUrl: './pi-v2-opp-scheme.component.scss'
})
export class PiV2OppSchemeComponent {
  @Input() schemaFinancial: string[];
  @Input() schemaDescription: string;

  public chart: any;

  ngOnInit(): void {
    setTimeout(() => {
      this.createChart();
    }, 500)
   }

  screenSize() {
    if (window.innerWidth < 991) return 'bottom';
    return 'right';
  }

 
  createChart(){
    this.schemaFinancial = this.schemaFinancial?.map(item => item?.replace('||', '|'));
    const data = this.schemaFinancial?.map(item => parseInt(item?.split('|')[1])); 
    const labels =this.schemaFinancial?.map(item => item?.split('|')[0]);
    const percentages = this.schemaFinancial?.map(item => item?.split('|')[2]);
    const total = data?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const labelsvalues = data?.map((value, i) => {
      let percent = Math.round((value / total) * 100) + '%';
      let formattedValue = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(value);
      return `${labels[i]} ${percent} $${formattedValue}`;
    });

    const alwaysShowTooltip ={
      id : 'alwaysShowTooltip',
      afterDraw(chart,args, options){
        const{ctx} = chart;
        ctx.save();

        chart.data.datasets.forEach(( dataset, i) => {
          chart.getDatasetMeta(i).data.forEach((datapoint, index) => {
            const {x,y} = datapoint.tooltipPosition();
            const value = chart.data.datasets[i].data[index];
                          //datos de empresa                         //cantidad 
                          const text = value.toString().length > 3 
                          ? '$ ' + new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(value) 
                          : value + '%';
            const textWidth = ctx.measureText(text).width;

            ctx.fillStyle = 'white';
            ctx.fillRect ( x - ((textWidth + 10) / 2),  y - 15,textWidth + 10, 20);
          

            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x - 5, y -5);
            ctx.lineTo(x - 5, y -5);
            ctx.fill();
          

            ctx.font = '15px';
            ctx.fillStyle = 'black';
            ctx.fillText(text, x - (textWidth / 2), y - 2);
            ctx.restore();
   
          }) 
        })

      }
    }
    

    const ctx = document.getElementById('MyChart') as HTMLCanvasElement;
    if(ctx) {
      this.chart = new Chart(ctx, {
        type: 'doughnut', 
  
    
        data: {
        labels: labelsvalues,
        datasets: [{
          label: '$',
          data: data,
          backgroundColor: [
            '#003A4C',
            '#79AAC0',
            '#0B7E92',		
        ],
          hoverOffset: 4
        }],
        },
  
        options: {
          plugins:{
            tooltip:{
              enabled: false,
            },
            legend: {
              position: this.screenSize(),
              labels:{
                usePointStyle: true,
              }
            }
          },
          aspectRatio:1 ,
          responsive: true,
          hover: {
            mode: 'index',
          }
        },
        plugins: [alwaysShowTooltip]
      });
    }
  }

}
